import { useRoute } from "vue-router";
import { ref } from "vue";
import { useStore } from "vuex";
import useFeLocalStorage from "./useFeLocalStorage";

const swapProjects = () => {
    const store = useStore()
    const projectId = ref(store.state.fe_project)
    const gotoUrl = ref(useRoute().query.goto)
    const HsLocalInfo = useFeLocalStorage('30baab36-b0ca-4e4e-9e33-827d5c9c6096', {
        "projectId":null, 
        "projectName":null, 
        "currentUser":null, 
        "SSRSReportPath":null, 
        "SSRSReportPath":null 
    })
    const projectDateStorage = useFeLocalStorage('fe_projectLastActive', "<<NOT FOUND>>")
    console.log(projectDateStorage.value, "@@@")
    const onSubmitProjectId = (inval, isSidebar=false, goTo=true) => {
        HsLocalInfo.value = null
        //!!!!!!!!! - KEY TO THE PROJECT RUNNING OK WRT projects
        console.log('HsLocalInfo0',HsLocalInfo, inval)
        if (inval === undefined || inval === null){
            
            HsLocalInfo.value =  {"projectId":null}
            console.log('HsLocalInfoA',HsLocalInfo.value)
            HsLocalInfo.value.projectId = projectId.value
        } else {
            let bob = JSON.parse(JSON.stringify(HsLocalInfo.value))
            bob.projectId = inval

            
            // {"projectId":null}
            console.log('HsLocalInfoB',HsLocalInfo.value, inval)
            HsLocalInfo.value = bob
            //HsLocalInfo.value['projectId'] = inval
            console.log('HsLocalInfoB2',HsLocalInfo.value)
        }
        console.log('fe_setProject',projectId.value, inval)
        //HsLocalInfo.value =  {"projectId":projectId.value} //saves it for the next time the browser needs to know "last project"

        //if we are coming in from the projects screen, use projectId

        if (!isSidebar) {
            store.commit('fe_setProject', projectId.value ); //saves it locally for the app to run - the is is the value you pull from all the time
        } else {
            //use the value stored in inval
            store.commit('fe_setProject', inval)
        }
        //!!!!!!!!!
        storeDateActive(inval)

        //store the date and time of the project becoming active

        if (!gotoUrl.value) {
            gotoUrl.value = '/'
        }
        console.log("moving onto " + gotoUrl.value, projectId.value)
        //$router.push({"path": gotoUrl.value});
        if (goTo) {
            window.location.href = gotoUrl.value  //this will trigger the router to reload the project data
        }

    }

    const storeDateActive = (projectIn) => {
        let objectToCommit = {}
        let time = new Date()

        if (projectDateStorage.value == "<<NOT FOUND>>") {
            //create a new object and add the date to it
            objectToCommit[projectIn] = time.toUTCString()
            console.log("still making it to the <<NOT FOUND>>")
            projectDateStorage.value = objectToCommit
        } else {
            objectToCommit = JSON.parse(JSON.stringify(projectDateStorage.value))
            objectToCommit[projectIn] = time.toUTCString()
            projectDateStorage.value = objectToCommit
        }
    }

    const getRecentProjects = (numberToRetrieve, projects) => {
        //here we will need to pull the dates from local storage
        //separates the new array created from the one in local storage
        let projectsToReturn = []
        let noDatesStored = false
        //if there is nothing stored in local storage
        //return a default array full
        if (projectDateStorage.value == "<<NOT FOUND>>") {
            for (let i = 0; i < numberToRetrieve; i++) {
                projectsToReturn.push(projects[i])
            }
            noDatesStored = true
        }
        
        if (!noDatesStored) {
            let projectDates = JSON.parse(JSON.stringify(projectDateStorage.value))

            //sort the dates
            let projectIds = Object.keys(projectDates)

            projectIds = projectIds.sort((a, b) => {
                //get the corresponding date of each of the projects
                let dateA = new Date(projectDates[a])
                let dateB = new Date(projectDates[b])

                return dateB - dateA
            })

            console.log("ids sorted by date: ", projectIds)

            //populate the projects to return with the corresponding
            //projects
            let numberOfIterations = projectIds.length < numberToRetrieve
                ? projectIds.length
                : numberToRetrieve

            for (let i = 0; i < numberOfIterations; i++) {
                let id = parseInt(projectIds[i])
                let projectToAdd = projects.find(item => item.id === id)
                projectsToReturn.push(projectToAdd)
            }

            //if there aren't enough projects with dates
            //fill the remaining slots with general projects
            console.log("The number of projects currently added: ", projectsToReturn.length, numberToRetrieve)
            if (projectsToReturn.length < numberToRetrieve) {
                //console.log("we are not storing enough values")
                //loop through the projects, and add the first ones
                //not already in the array
                projects.forEach(project => {
                   // console.log("the current project: ", project)
                    if (!projectsToReturn.includes(project) && projectsToReturn.length < numberToRetrieve) {
                        projectsToReturn.push(project)
                    }
                })
            }
            
            // Make temp copy, and remove all projects over numberRetrieved + 6, and then set the temp copy back
            let projectDateStorageCopy = projectDateStorage.value
            for (let i = numberToRetrieve+6; i < projectIds.length; i++) {
                delete projectDateStorageCopy[projectIds[i]]
            }
            projectDateStorage.value = projectDateStorageCopy
        }

        console.log("Returning these projects: ", projectsToReturn)

        return projectsToReturn
    }

    return { onSubmitProjectId, getRecentProjects }
}

export default swapProjects
